module.exports = __webpack_public_path__ + "static/img/蒙版组 307@2x.83c6ab44.png";